const remoteAsDefault = 'remoteAsDefault'

const remotePath = '/remote'
const isRemoteDefault = () => localStorage.getItem(remoteAsDefault)
const setRemoteDefault = () => localStorage.setItem(remoteAsDefault, remotePath)
const removeRemoteDefault = () => localStorage.removeItem(remoteAsDefault)

export { remotePath, isRemoteDefault, setRemoteDefault, removeRemoteDefault }
